import {getLanguage, DEFAULT_LANGUAGE} from './language';

export const dictionary = {
  no: {
    PLAYER_START: 'Start',
    PLAYER_START_SPEED_COURSE: 'Kjør på!',
    ANSWER_CORRECT: 'Riktig',
    ANSWER_WRONG: 'Feil',
    SPEED_COURSE: 'Hurtigquiz',
    COURSE_RESULT_FAIL: 'Prøv igjen',
    COURSE_RESULT_SCORE: 'Din poengsum',
    COURSE_RESULT: 'Resultat',
    POINTS: 'poeng',
    OF: 'av',
    CLOSE: 'Lukk',
    PLAYER_HINT_ORDER: 'Trykk på svaralternativene i riktig rekkefølge fra 1 til ',
    PLAYER_NEXT: 'Neste',
    PLAYER_PREV: 'Tilbake',
    PLAYER_EXIT: 'Avslutt',
    PLAYER_FINALIZE: 'Avslutt',
    PLAYER_CLOSE_BROWSER: 'Kurset er avsluttet du kan lukke vindu',
    PLAYER_CLOSE_COURSE: 'Lukk kurs',
    PLAYER_SUBMIT_QUIZ_ANSWER: 'Svar',
    PLAYER_FLIP_DILEMMA_CARD: 'Flipp kort',
    PLAYER_ARIA_DILEMMA_CARD: 'Dilemma-kort',
    PLAYER_NO_CONTENT_FOUND: 'Fant ikke innhold',
    ERROR_OCCURED: 'Det oppstod en feil',
    PLAYER_QUIZ_ANSWER_COMMENT_CORRECT: 'Riktig',
    PLAYER_QUIZ_ANSWER_COMMENT_WRONG: 'Ikke riktig',
    PLAYER_QUIZ_WRONG_ANSWER: 'Feil svar',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_CORRECT: 'Bra jobbet!',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_WRONG: 'Dessverre feil.',
    PLAYER_CONTINUE: 'Fortsett',
    PLAYER_RETRY: 'Prøv igjen',
    PAGE_LOADING_RESOURSES: 'Laster [x] av [y] resurser',
    PAGE_LOADING_IMAGE: 'resurser',
    PAGE_LOADING: 'Laster...',
  },
  en: {
    PLAYER_START: 'Start',
    PLAYER_START_SPEED_COURSE: 'Let\'s go!',
    ANSWER_CORRECT: 'Correct',
    ANSWER_WRONG: 'Wrong',
    SPEED_COURSE: 'Speed Quiz',
    COURSE_RESULT_FAIL: 'Try again',
    COURSE_RESULT_SCORE: 'Your score',
    COURSE_RESULT: 'Result',
    POINTS: 'points',
    OF: 'of',
    CLOSE: 'Close',
    PLAYER_HINT_ORDER: 'Click the alternatives in correct order from 1 to ',
    PLAYER_NEXT: 'Next',
    PLAYER_PREV: 'Back',
    PLAYER_EXIT: 'Exit',
    PLAYER_FINALIZE: 'Finish',
    PLAYER_CLOSE_BROWSER: 'The course is finished, you can now close the window',
    PLAYER_CLOSE_COURSE: 'Close course',
    PLAYER_SUBMIT_QUIZ_ANSWER: 'Submit',
    PLAYER_FLIP_DILEMMA_CARD: 'Flip card',
    PLAYER_ARIA_DILEMMA_CARD: 'Dilemma card',
    PLAYER_NO_CONTENT_FOUND: 'No content found',
    ERROR_OCCURED: 'An error occurred',
    PLAYER_QUIZ_ANSWER_COMMENT_CORRECT: 'Correct',
    PLAYER_QUIZ_ANSWER_COMMENT_WRONG: 'Incorrect',
    PLAYER_QUIZ_WRONG_ANSWER: 'Wrong answer',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_CORRECT: 'Good job!',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_WRONG: 'That wasn\'t the right answer.',
    PLAYER_CONTINUE: 'Continue',
    PLAYER_RETRY: 'Try again',
    PAGE_LOADING_RESOURSES: 'Loading [x] of [y] resources',
    PAGE_LOADING_IMAGE: 'resources',
    PAGE_LOADING: 'Loading ...',
  },
  sv: {
    PLAYER_START: 'Starta',
    PLAYER_START_SPEED_COURSE: 'Kör igång!',
    ANSWER_CORRECT: 'Rätt',
    ANSWER_WRONG: 'Fel',
    SPEED_COURSE: 'Snabbquiz',
    COURSE_RESULT_FAIL: 'Försök igen',
    COURSE_RESULT_SCORE: 'Din poäng',
    COURSE_RESULT: 'Resultat',
    POINTS: 'poäng',
    OF: 'av',
    CLOSE: 'Stäng',
    PLAYER_HINT_ORDER: 'Tryck på svarsalternativen i rätt ordning från 1 till ',
    PLAYER_NEXT: 'Nästa',
    PLAYER_PREV: 'Tillbaka',
    PLAYER_EXIT: 'Stäng',
    PLAYER_FINALIZE: 'Avsluta',
    PLAYER_CLOSE_BROWSER: 'Kursen är avslutad, du kan stänga fönstret',
    PLAYER_CLOSE_COURSE: 'Avsluta kurs',
    PLAYER_SUBMIT_QUIZ_ANSWER: 'Svara',
    PLAYER_FLIP_DILEMMA_CARD: 'Vänd kort',
    PLAYER_ARIA_DILEMMA_CARD: 'Dilemmakort',
    PLAYER_NO_CONTENT_FOUND: 'Inget innehåll hittades',
    ERROR_OCCURED: 'Något gick fel',
    PLAYER_QUIZ_ANSWER_COMMENT_CORRECT: 'Rätt',
    PLAYER_QUIZ_ANSWER_COMMENT_WRONG: 'Inte rätt',
    PLAYER_QUIZ_WRONG_ANSWER: 'Fel svar',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_CORRECT: 'Bra jobbat!',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_WRONG: 'Tyvärr fel.',
    PLAYER_CONTINUE: 'Fortsätt',
    PLAYER_RETRY: 'Försök igen',
    PAGE_LOADING_RESOURSES: 'Laddar [x] av [y] resurser',
    PAGE_LOADING_IMAGE: 'resurser',
    PAGE_LOADING: 'Laddar...',
  },
};

// Externally-supplied player strings, kept separate from the baked-in
// dictionaries: merging them into `dictionary` would let an unsupported SCORM
// locale (which getLanguage() clamps to `no`) permanently contaminate the
// shared `no` base, and would defeat the per-key fallback below for any key
// the external payload lacks.
let externalOverlay = null;

let mergedCache = null;
let mergedCacheLang = null;

/**
 * Overlays externally-supplied player strings (only used by the SCORM build,
 * which bakes its dictionary into the course payload). The online player
 * no longer overlays grape's dictionary — see initializeCoursePlayer.
 */
export const setDictionary = newDictionary => {
  externalOverlay = {...externalOverlay, ...newDictionary};
  mergedCache = null;
};

export const getDictionary = () => {
  const lang = getLanguage();

  if (!mergedCache || mergedCacheLang !== lang) {
    // Base on the default language so any key missing from `lang` (or from
    // the external overlay) falls back instead of rendering `undefined`.
    mergedCache = {...dictionary[DEFAULT_LANGUAGE], ...dictionary[lang], ...externalOverlay};
    mergedCacheLang = lang;
  }

  return mergedCache;
};
